{
  "version": 1,
  "asset_id": "08837b6c-36a6-4cbd-a2ad-d67c67c48ce1",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/08837b6c-36a6-4cbd-a2ad-d67c67c48ce1/lecanto-metal-roof-before-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/08837b6c-36a6-4cbd-a2ad-d67c67c48ce1/lecanto-metal-roof-before-768w.webp",
  "original_filename": "lecanto-metal-roof-before-768w.webp",
  "size": 143288,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
